import { graphqlClient } from "../../../client";
import getTweakwiseIdQuery from "./getTweakwiseIdQuery.graphql";
import type { RetrieveEnvironmentIdResultType, Query } from "@/core/api/graphql/types";

export async function getTweakwiseId(): Promise<RetrieveEnvironmentIdResultType> {
  const { data } = await graphqlClient.query<
    Required<Pick<Query, "retrieveEnvironmentId">>,
    RetrieveEnvironmentIdResultType
  >({
    query: getTweakwiseIdQuery,
  });

  return data.retrieveEnvironmentId;
}
